module.exports = __webpack_public_path__ + "static/media/react.f1720304.svg";